export const NEXT_CLOUD_INSIGHTS = 'Product Analytics';

export const OVERVIEW = 'Overview';
export const ENTERTAINMENT = 'Entertainment';
export const SEATBACK = 'Seatback';
export const PORTAL = 'Portal';
export const MARKETPLACE = 'Marketplace';
export const Connectivity = 'Connectivity';
